import { render } from "./EditEmpruntPage.vue?vue&type=template&id=6d3ef108&ts=true"
import script from "./EditEmpruntPage.vue?vue&type=script&lang=ts"
export * from "./EditEmpruntPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__